import { render, staticRenderFns } from "./notLogin.vue?vue&type=template&id=5da10691&scoped=true"
import script from "./notLogin.vue?vue&type=script&lang=js"
export * from "./notLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da10691",
  null
  
)

export default component.exports